import { ReactNode, useRef } from "react";

type ColumnCellRenderer = (info: unknown) => ReactNode;

type ColumnWithCell = { id?: string; cell?: unknown };

export const useStableColumnCells = () => {
  const latestCellsRef = useRef(new Map<string, ColumnCellRenderer>());
  const stableCellsRef = useRef(new Map<string, ColumnCellRenderer>());

  const getStableCell = (columnId: string) => {
    const existing = stableCellsRef.current.get(columnId);
    if (existing) {
      return existing;
    }
    const stable: ColumnCellRenderer = (info) => latestCellsRef.current.get(columnId)?.(info);
    stableCellsRef.current.set(columnId, stable);
    return stable;
  };

  const stabilizeColumnCells = <COLUMN extends ColumnWithCell>(columns: COLUMN[]): COLUMN[] =>
    columns.map((column) => {
      if (typeof column.cell !== "function") {
        return column;
      }
      const columnId = column.id as string;
      latestCellsRef.current.set(columnId, column.cell as ColumnCellRenderer);
      return { ...column, cell: getStableCell(columnId) };
    });

  return { stabilizeColumnCells };
};
